import React from 'react';
import EventDetailsContainer from '../../../../Containers/UserContainer/PbssInternational/EventDetails';

const EventDetailsScreen = () => {
  return <EventDetailsContainer />;
};

export default EventDetailsScreen;
